import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=324163be&scoped=true"
import script from "./MyCompany.vue?vue&type=script&lang=ts"
export * from "./MyCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324163be",
  null
  
)

export default component.exports